const axios = require("axios");

class WpApi {
  constructor() {
    this.apiBase = "https://blog.jlaasociados.net/wp-json"
  }

  posts() {
    return axios.get(`${this.apiBase}/wp/v2/posts`, {
      params: {
        page: 1,
        per_page: 6
      }
    })
      .then(json => {
        return {posts: json.data}
      })
      .catch(e => {
        return {error: e}
      })
  }

  posts(page) {
    return axios.get(`${this.apiBase}/wp/v2/posts?page=${page}`, {
      params: {
        per_page: 6
      }
    })
      .then(json => {
        return {posts: json.data}
      })
      .catch(e => {
        return {error: e}
      })
  }

  getPostBySlug(slug) {
    ///wp-json/wp/v2/posts?slug=
    return axios.get(`${this.apiBase}/wp/v2/posts?slug=${slug}`, {
      params: {
        page: 1,
        per_page: 5
      }
    })
      .then(json => {
        return {posts: json.data}
      })
      .catch(e => {
        return {error: e}
      })
  }

  async getCategory(id) {
    ///wp-json/wp/v2/posts?slug=
    return axios.get(`${this.apiBase}/wp/v2/categories/${id}`, {
      params: {
        page: 1,
        per_page: 5
      }
    })
      .then(json => {
        console.log(json.data.name)
        return json.data

      })
      .catch(e => {
        return {error: e}
      })
  }

  getCategories() {
    ///wp-json/wp/v2/posts?slug=
    return axios.get(`${this.apiBase}/wp/v2/categories/`, {
      params: {
        page: 1,
        per_page: 5
      }
    })
      .then(json => {
        return json.data
      })
      .catch(e => {
        return {error: e}
      })
  }


  getCategoryList(list, categories) {
    return categories.reduce(function (prevVal, currVal, idx) {
      if (list.includes(currVal.id)) {
        return idx == 0 ? currVal.name : prevVal + ', ' + currVal.name;
      }
    })
  }

  getMaxNumberOfPages(numPost, postPerPage) {
    var maxNumberOfPages = numPost / postPerPage
    if (numPost % postPerPage > 0)
      maxNumberOfPages++
    return Math.trunc(maxNumberOfPages)
  }

}

export const blog = {
  WpApi
}

